var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"table-card",attrs:{"width":_vm.width,"height":_vm.height,"color":_vm.color}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }